module.exports = __webpack_public_path__ + "static/media/piso-inferior-reunioes.60d99128.jpg";